import React from 'react';
import { View, StyleSheet } from 'react-native';
import Skeleton from '../common/Skeleton';

const LedgerEntrySkeleton: React.FC = () => {
  return (
    <View style={styles.container}>
      <View style={styles.left}>
        <Skeleton width={48} height={48} borderRadius={8} />
        <View style={styles.info}>
          <Skeleton width={140} height={16} borderRadius={4} />
          <Skeleton width={100} height={12} borderRadius={4} style={{ marginTop: 6 }} />
        </View>
      </View>
      <View style={styles.right}>
        <Skeleton width={80} height={18} borderRadius={4} />
        <Skeleton width={60} height={12} borderRadius={4} style={{ marginTop: 4 }} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 8,
  },
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  info: {
    marginLeft: 12,
    flex: 1,
  },
  right: {
    alignItems: 'flex-end',
  },
});

export default LedgerEntrySkeleton;
